import { Button } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { Icon, toastNotifications, variants } from '@uag/react-core';
import { useResendInvitation } from '@uag/welcome-shared/src/api/queries/invitations/invitations';
import {
    getGetRequestDetailQueryKey,
    getGetRequestsQueryKey,
} from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useTranslation } from 'react-i18next';

import { useRequestContext } from '../RequestProvider';
import { RequestActionButtonProps } from './types';

export const ResendInvitation = (_: RequestActionButtonProps) => {
    const { t } = useTranslation();
    const { mutateAsync: resendInvitation, isPending: isVerifyPending } = useResendInvitation();
    const queryClient = useQueryClient();
    const { request } = useRequestContext();

    const handleResendInvitation = async () => {
        try {
            await resendInvitation({ id: request.id });
            toastNotifications.success({
                title: t('success'),
                message: t('invitationResent'),
            });
        } catch (error) {
            toastNotifications.errorDetail(
                {
                    title: t('failed'),
                    message: t('resendInvitationFailed'),
                },
                error,
            );
        }
        queryClient.invalidateQueries({ queryKey: getGetRequestDetailQueryKey(request.id) });
        queryClient.invalidateQueries({ queryKey: getGetRequestsQueryKey() });
    };

    return (
        <Button loading={isVerifyPending} variant={variants.button.secondary} onClick={handleResendInvitation}>
            {t('resendInvitation')}
            <Icon className="ml-base" icon="notifications" />
        </Button>
    );
};
